import React from "react";
import Utils from "../Utils/Utils";

const STORYBLOK_PREFIX = "https://a.storyblok.com/";
const DEFAULT_WIDTHS = [400, 768, 1024, 1280, 1920];

interface StoryblokImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet" | "loading"> {
  src: string | undefined | null;
  lazy?: boolean;
  sizes?: string;
  widths?: number[];
  fallbackSrc?: string;
}

const StoryblokImage: React.FC<StoryblokImageProps> = ({
  src,
  alt = "",
  lazy = true,
  sizes,
  widths = DEFAULT_WIDTHS,
  fallbackSrc,
  ...rest
}) => {
  if (!src) return null;

  const isStoryblok = src.startsWith(STORYBLOK_PREFIX);
  const resolvedFallback = fallbackSrc ?? (isStoryblok ? src : undefined);

  const imgSrc = Utils.getCacheUrl(src);

  let srcSet: string | undefined;
  if (isStoryblok) {
    srcSet = widths
      .map((w) => `${Utils.getCacheUrl(`${src}/m/${w}x0`)} ${w}w`)
      .join(", ");
  }

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const img = e.currentTarget;
    if (resolvedFallback && img.src !== resolvedFallback) {
      img.srcset = "";
      img.src = resolvedFallback;
    }
  };

  return (
    <img
      src={imgSrc}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      loading={lazy ? "lazy" : "eager"}
      alt={alt}
      onError={handleError}
      {...rest}
    />
  );
};

export default StoryblokImage;
